module.exports = __webpack_public_path__ + "static/media/privacyPolicy.9c60be24.svg";